import {
  AllResourceResponse,
  FilterResourceType,
  FiltersApiResponse,
} from "@/components/PageAllResources/api/interface";
import { fetchAllResourceAPI, fetchAllResourceFiltersAPI } from "@/components/PageAllResources/api";

export const fetchFilterData = async (
  searchParams?: any,
  resourceType?: FilterResourceType,
  pageUrl?: string,
  apolloLogger?: any,
  correlationId?: string
): Promise<FiltersApiResponse | {}> => {
  try {
    const payload = searchParams
      ? Object.fromEntries(Object.entries(searchParams)?.map(([key, value]: any) => [key, value.split(",")]) || [])
      : {};

    if (resourceType) {
      payload["CollectionType"] = [resourceType];
    }

    return await fetchAllResourceFiltersAPI(payload, pageUrl, apolloLogger, correlationId);
  } catch (e) {
    console.error({ e });

    return {};
  }
};

export const fetchResourceData: (
  searchParams?: any,
  pageUrl?: string,
  apolloLogger?: any,
  correlationId?: string
) => Promise<AllResourceResponse> = async (searchParams, pageUrl, apolloLogger, correlationId) => {
  try {
    const payload = searchParams
      ? Object.fromEntries(Object.entries(searchParams)?.map(([key, value]: any) => [key, value.split(",")]) || [])
      : {};

    return fetchAllResourceAPI(payload, pageUrl, apolloLogger, correlationId);
  } catch (e) {
    console.error({ e });
  }

  return null;
};
